import React from 'react';
import { withTranslation } from 'react-i18next';
import { translate } from '../../utils/util';

const BackButton = (props) => {

    const goBack = () => {
        if (props.callback) {
            props.callback();
        }
        if (props.onClick) {
            props.onClick(props.history);
        } else {
            if (props.history.location.pathname.includes('/digital/shipment/').length > 17) {
                props.history.push('/home');
            } else if (props.history.location.pathname === '/linePicking/smallParts/readQrCode' && props.history?.location.state?.route === 'filter/partnumber') {
                props.history.go(-2);
            }
            else {
                props.history.goBack();
            }
        }
    };

    return (
        <div className="row" style={{ marginBottom: '0px' }} >
            <button type="button" className="col s12 btn btn-principal waves-effect waves-light" onClick={goBack}>
                <div className="left" >
                    <i className="material-icons" style={{ marginRight: '5px', marginTop: '2px' }}>arrow_back</i>
                </div>
                <div className="left">
                    <label style={{ color: 'white', fontWeight: 'bold' }}>
                        {translate('back', 'general')}
                    </label>
                </div>
            </button>
        </div>
    );
};

export default withTranslation()(BackButton);
